import { put, select } from "redux-saga/effects";

import type { ApplyInitiativesSearchCriteriaAction } from "domains/initiatives/actionTypes";
import { getInitiativesSearchCriteria } from "domains/initiatives/selectors";
import { getTmSelectedId } from "domains/transformationMap/selectors";
import { fetchInitiativesForTopic } from "entities/initiatives/actions";

export function* applyInitiativesSearchCriteriaSaga(action: ApplyInitiativesSearchCriteriaAction) {
  const searchCriteria: ReturnType<typeof getInitiativesSearchCriteria> = yield select(getInitiativesSearchCriteria);
  const transformationMapSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  // NOTE I think that the below is to do with the 'initiatives filter not working issue'
  // https://github.com/Serendipity-AI/intelligence-frontend/issues/2030
  // There are inconsistent expectations around whether 'topicId' or 'id' is passed for initiatives specifically
  // Search criteria/filter state could benefit from being written with much more specific typing
  const id = action.payload["topicId"] ?? transformationMapSelectedId;
  if (typeof id === "string") yield put(fetchInitiativesForTopic({ ...searchCriteria, id }));
}
